<!-- ********************MOBILE-VIEW******************** -->


<div class="divLineup_mobile" style="background-color: white;">

    <div fxLayout="row"  fxFlex="37">

         <span>

             <img class="image_mobile" src="{{premiere.mobilethumbimage}}"/>

         </span>

     </div>

     <div fxFlex="63" fxLayout="row wrap">

         <h3   class="spotlightsDate_mobile">
             {{premiere.cinejoySpotlightsSchedule[0].scheduleTimeText | date:'EEE, MMM d, y, h:mm:ss a'}} {{timezone}}<br>
         </h3>

         <h3 fxFlex.lt-md="100"  class="spotLightsTitle_mobile">{{premiere.name}}</h3>

         <div fxLayoutAlign="start" fxLayout="row" style="margin-left: 10px;"
              class="spotlight_button_mobile" fxLayoutGap="6px" *ngIf="!archive">

             <button id="btn_mobile" (click)="open(premiere.eventId, premiere, 'Buy')" *ngIf="!isBuyButtonActive">Buy</button>
             <button id="btn_mobile" (click)="redirect()"  [disabled] ="joinButtonDisabled">Join</button>
             <button id="btn_mobile" (click)="gotoMoreInfo(premiere.eventId,premierename)">More Info</button>
             <button id="btn_mobile" (click)="openDialog(premiere)" style="margin-top: 5px;"
             *ngIf="isBuyButtonActive && joinButtonDisabled">
             <ng-container *ngIf="!exsistingGroup">Create Group</ng-container>
             <ng-container *ngIf="exsistingGroup">Manage Group</ng-container></button>
         </div>

         <div fxLayoutAlign="start" fxLayout="row" style="margin-left: 11px; text-align: center !important;"
              class="spotlight_button_mobile" fxLayoutGap="6px" *ngIf="archive">

             <button id="btn_mobile" (click)="gotoMoreInfo(premiere.eventId,premierename)">More Info</button>

         </div>

     </div>

</div>

<!-- ********************MOBILE-VIEW ENDED******************** -->
